import { useTranslation } from "react-i18next"

import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

export const useBuildCertificatesSorts = () => {
  const { sorts, setSorts } = useCertificatesTableContext()
  const { t } = useTranslation("certificates")
  return {
    sorts,
    setSorts,
    sortOptions: [
      { label: t("sorts.name"), value: "name" },
      { label: t("sorts.issueDate"), value: "issueDate" },
      { label: t("sorts.expiryDate"), value: "expiryDate" },
      { label: t("sorts.reference"), value: "reference" },
      { label: t("sorts.documentStatus"), value: "documentStatus" },
      { label: t("sorts.productionSite"), value: "productionSite" },
      { label: t("sorts.score"), value: "score" },
      { label: t("sorts.createdAt"), value: "createdAt" },
      { label: t("sorts.category"), value: "category" },
      { label: t("sorts.totalRequests"), value: "totalRequests" },
    ],
  }
}
